"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataExportTemplate_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var DataExportTemplateMergeField_1 = require("./DataExportTemplateMergeField");
var DataExportTemplate_Factory = /** @class */ (function () {
    function DataExportTemplate_Factory() {
    }
    DataExportTemplate_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CategoryTypeId: model.CategoryTypeId,
            DataExportTemplateMergeFields: model.DataExportTemplateMergeFields && model.DataExportTemplateMergeFields.map(function (i) { return DataExportTemplateMergeField_1.DataExportTemplateMergeField_Factory.CreateIncoming(i); }),
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    DataExportTemplate_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CategoryTypeId: model.CategoryTypeId,
            DataExportTemplateMergeFields: model.DataExportTemplateMergeFields && model.DataExportTemplateMergeFields.map(function (i) { return DataExportTemplateMergeField_1.DataExportTemplateMergeField_Factory.CreateOutgoing(i); }),
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return DataExportTemplate_Factory;
}());
exports.DataExportTemplate_Factory = DataExportTemplate_Factory;
